<template>
    <div>
        <canvas ref="qrCanvas"></canvas>
    </div>
</template>

<script>
    import QRCode from 'qrcode'

    export default {
        props: {
            text: {
                type: String,
                required: true
            }
        },
        mounted() {
            this.generateQRCode()
        },
        methods: {
            generateQRCode() {
                QRCode.toCanvas(this.$refs.qrCanvas, this.text, error => {
                    if (error) console.error(error)
                })
            }
        }
    }
</script>

<style>
    canvas{
        width: 48px !important;
        height: 48px !important;
    }
</style>